import { ENV_NAME } from "pages/webview/instructor/program-state.service"

export type Gesture = "click"|"swipe"
export interface IGesture {
  value: Gesture,
  label: string
}

export type SwipeDirection = "up"|"down"|"left"|"right"
export interface ISwipeDirection {
  value: SwipeDirection,
  label: string
}

export class Constants {
  static API = {
    PATH: '/web_api',
    PUBLIC_PATH: '/public_web_api'
  }

  static APP = {
    NAME: 'Yandex Pro'
  }

  static ENV = {
    env: process.env.ENV,
    isDevelopment: process.env.ENV == "development",
    isStaging: process.env.ENV == "staging",
    isPreProduction: process.env.ENV == "preprod",
    isProduction: process.env.ENV == "production"
  }

  static CAMPUS_INSTRUCTOR_HOST_MAP = {
    development: "http://localhost:4201",
    staging: "https://instructor-dev.vmb.co",
    production: "https://education.training.yandex"
  }

  static get campusInstructorHost() {
    return Constants.CAMPUS_INSTRUCTOR_HOST_MAP[Constants.ENV.env]
  }

  static PAGE_PATHS = {
    SIGN_IN: '/sign_in'
  }

  static EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i
  static PHONE_REGEXP = /^\d{7,12}$/

  static CENTERS = {
    MIN_PASSWORD_LENGTH: 2
  }

  static EXAMS = {
    MIN_GRADE: 0,
    MAX_GRADE: 5
  }

  static GESTURES: IGesture[] = [
    {
      value: 'click',
      label: 'Нажатие'
    },
    {
      value: 'swipe',
      label: 'Свайп'
    }
  ]

  static SWIPE_DIRECTIONS: ISwipeDirection[] = [
    {
      value: 'up',
      label: 'Вверх'
    },
    {
      value: 'down',
      label: 'Вниз'
    },
    {
      value: 'left',
      label: 'Влево'
    },
    {
      value: 'right',
      label: 'Вправо'
    }
  ]

  static PROGRAMS = {
    MIN_PASSWORD_LENGTH: 2
  }

  static QUESTIONS = {
    TYPES: ['select', 'multiselect', 'string']
  }

  static SESSIONS = {
    APPROVAL_STATES: ['not_checked', 'accessor_started', 'approved', 'rejected'],
    MAX_ACCESSOR_COMMENT_LENGTH: 1000,
    STATES: ['started', 'exam_started', 'completed', 'cancelled']
  }

  static USERS = {
    MIN_PASSWORD_LENGTH: 5,
    ROLES: [
      'admin', 'accessor', 'technician', 'center_member', 'content_editor',
      'phone_controller', 'interviewer', 'moderator', 'online_interviewer', 'support', 'hub_coordinator'
    ],
    WEB_ROLES: [
      'admin', 'accessor', 'center_member', 'content_editor', 'video_accessor', 'phone_controller', 'hub_coordinator',
      'interviewer', 'moderator', 'online_interviewer', 'support'
    ]
  }

  static HUBS = {
    COURSES: ['econom', 'business', 'special', 'kids']
  }

  static VIDEOS = {
    MAX_FILE_SIZE: 52428800 // 50mb
  }

  static SPEECHES = {
    MAX_FILE_SIZE: 5242880 // 5mb
  }

  static CKEDITOR_ASSETS_VERSION = 3

  static ONLINE_LEARNING_SESSIONS = {
    STATES: ['started','exam_started', 'waiting_briefing_registration', 'waiting_interview', 'waiting_briefing', 'interview','completed','canceled']
  }

  static INFRACTIONS = {
    TYPE_OPTIONS: [
      { label: "Обычное", value: "Default"},
      { label: "С указанием причины", value: "Reasonable"}
    ]
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/config/constants.ts